import { Component } from '@angular/core';
import {AlertController, ModalController, NavController, NavParams} from 'ionic-angular';
import * as _ from 'lodash';

import { Location } from '../../models/location';
import { Data } from '../../providers/providers';
import { Thinning } from '../../providers/providers';
import { ThinningDataset } from '../../models/thinning-dataset';
import { ThinningMeasurement } from "../../models/thinning-measurement";
import { Observable } from "rxjs/index";

/* Tabular view of measurement summaries (currently not used) */
@Component({
  selector: 'page-thinning-dataset-summary',
  templateUrl: 'thinning-dataset-summary.html'
})
export class ThinningDatasetSummaryPage {

  location: Location;
  dataset: ThinningDataset;
  measurements: Observable<ThinningMeasurement[]>;

  public showColumns: any[];

  constructor(public navCtrl: NavController,
              public modalCtrl: ModalController,
              private alertCtrl: AlertController,
              navParams: NavParams,
              public data: Data,
              public thinning: Thinning)
  {
    const self = this;
    this.location = navParams.get('location');
    this.dataset = navParams.get('dataset');
    this.measurements = data.getThinningMeasurementsCollection(this.dataset).valueChanges();

    this.showColumns = [
      'created',
      // 'days_since_last',
      'mean_of_top_15_by_diameter',
      // 'mean_of_all_by_diameter',
      'mean_of_top_15_by_diameter_growth',
      // 'half_mean_of_top_15_by_diameter_growth',
      // 'count_of_over_50_pct_fastest',
      // 'count_of_under_50_pct_fastest',
      // 'count_of_measured_fruit',
      // 'predicted_pct_setting',
    ];
  }

  columnSelected(cols) {
    return _.some(this.showColumns, (col) => _.indexOf(cols, col) != -1);
  }

  howManyColumnsSelected(cols) {
    let val = 0;
    for (let col of this.showColumns) {
      if (_.indexOf(cols, col) != -1) {
        val += 1;
      }
    }
    return val;
  }

}



// WEBPACK FOOTER //
// ./src/pages/thinning-dataset-summary/thinning-dataset-summary.ts